import {Field, Form, FormElement, FormRenderProps} from "@progress/kendo-react-form"

import dayjs from "dayjs"
import Breadcrumb from "../../shared/CustomBreadcrumb"
import {useEffect, useState} from "react"

import PlannerScheduler from "../../components/MotBooking/PlannerScheduler"
import PlannerTestPackageCombo from "../../components/MotBooking/controls/plannerTestPackagesMultiCombo"
import DealerDropdown from "../../components/Shared/dealerDropdown"

import {RootState} from "../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../store"
import {fetchPlannerDataAction, fetchPlannerTestPackages, setPlannerTestPackge} from "../MotBooking/bookingSlice"

const Planner = () => {
    const dispatch = useAppDispatch()

    const selectedDealer = useAppSelector((state: RootState) => state.application.selectedSingleDealer)
    const weeklyDate = useAppSelector((state: RootState) => state.containers.motBooking.selectedWeeklyDate)
    const selectedPackage = useAppSelector((state: RootState) => state.containers.motBooking.selectedPackagePlanner)

    const [showScheduler, setShowScheduler] = useState(false)

    useEffect(() => {
        setShowScheduler(true)
    }, [])

    useEffect(() => {
        if (selectedDealer) {
            dispatch(
                fetchPlannerTestPackages(
                    selectedDealer && selectedDealer.dealerId,
                    dayjs(weeklyDate).format("YYYY-MM-DD"),
                ),
            )
        }
    }, [selectedDealer, weeklyDate, dispatch])

    useEffect(() => {
        if (selectedPackage === 0)
            setTimeout(() => dispatch(fetchPlannerDataAction(dayjs(weeklyDate).format("YYYY-MM-DD"), 0)), 300)
    }, [weeklyDate])

    useEffect(() => {
        if (selectedDealer) {
            dispatch(fetchPlannerDataAction(dayjs(weeklyDate).format("YYYY-MM-DD"), selectedPackage))
        }
    }, [dispatch, selectedDealer, selectedPackage])

    return (
        <>
            <Breadcrumb crumbs={['Manage MOT', 'Planner']} />
            <div className="mb-2">
                <Form
                    key={JSON.stringify({
                        plannerDealerID: selectedDealer?.dealerId,
                        plannerTestPackageID: selectedPackage,
                    })}
                    initialValues={{
                        plannerDealerID: selectedDealer?.dealerId,
                        plannerTestPackageID: selectedPackage,
                    }}
                    render={(formRenderProps: FormRenderProps) => (
                        <div className="mb-2">
                            <div className="align-items-end mb-2 row">
                                <div className="col-md-2 col-sm-3">
                                    <FormElement>
                                        <Field
                                            onChange={() => {
                                                dispatch(setPlannerTestPackge(0))
                                            }}
                                            name={"plannerDealerID"}
                                            component={DealerDropdown}
                                        />
                                    </FormElement>
                                </div>
                                <div className="col-md-4 col-sm-6">
                                    <FormElement>
                                        <PlannerTestPackageCombo />
                                    </FormElement>
                                 </div>
                            </div>
                        </div>
                    )}
                />
            </div>
            {showScheduler && <PlannerScheduler />}
        </>
    )
}

export default Planner
